import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetResourceCategories = () => {
  const get = useTypedApiClient({
    path: '/admin/resources/categories',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/resources/categories'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
